import React from 'react';

export const SliderContext = React.createContext({
  saveUserSession: () => {},
  getUserResult: () => {},
  getQuestionsCount: () => {},
  getFirstSlide: () => {},
});
export default SliderContext;
